import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import React, {memo} from 'react'

import {ParameterIcon} from '../Icon/ParameterIcon'

import styles from './ParametersModifyCheckbox.css'

interface Props {
  checked: boolean
  onChange(): void
}

function ParametersModifyCheckboxComponent(props: Props) {
  const {checked, onChange} = props
  return (
    <Checkbox
      containerClassName={styles.checkbox}
      cellClassName={styles.checkboxCell}
      labelClassName={styles.checkboxLabel}
      checked={checked}
      onChange={onChange}
    >
      {'Show only added '}
      <ParameterIcon className={styles.added} />
      {' and modified '}
      <ParameterIcon className={styles.modified} />
    </Checkbox>
  )
}

export const ParametersModifyCheckbox = memo(ParametersModifyCheckboxComponent)
